export default {
  columns: {
    version: 'Versión',
    signed_at: 'Firmado el',
    internal_note: 'Nota interna',
    signature_provider: 'Proveedor de firma',
    file: 'Documento',
    actions: 'Acciones',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Aún no hay historial de firmas',
    providers: {
      selfhosted: 'Alojado propio',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Vista previa',
    download: 'Descargar',
  },
};
